function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import Checkbox from '../checkbox';
import SwitchInput from '../switch-input';
import { gray800, gray900 } from '../../theme/colors';
import { size4, size8, size14, size16 } from '../../theme/scale';
import { fontSemiBold } from '../../theme/fonts';
const Wrapper = styled.div``;
const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: ${({
  horizontal
}) => horizontal ? 'row' : 'column'};
`;
const Legend = styled.legend`
  color: ${gray900};
  font-family: ${fontSemiBold};
  font-size: ${size16};
  margin-bottom: ${size4};
`;
const Hint = styled.p`
  color: ${gray800};
  font-size: ${size14};
  margin-bottom: ${size8};
`;
export const CheckboxGroup = ({
  options,
  value,
  disabled,
  horizontal = false,
  onChange,
  legend,
  hint,
  asSwitch = false,
  ...props
}) => {
  const toggleOption = optionValue => {
    onChange(value.includes(optionValue) ? value.filter(item => item !== optionValue) : [...value, optionValue]);
  };
  const Component = asSwitch ? SwitchInput : Checkbox;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    as: legend ? 'fieldset' : 'div'
  }, props), legend && /*#__PURE__*/React.createElement(Legend, null, legend), hint && /*#__PURE__*/React.createElement(Hint, null, hint), /*#__PURE__*/React.createElement(OptionsWrapper, {
    horizontal: horizontal
  }, options.map(({
    label,
    value: optionValue,
    hideLabel
  }) => /*#__PURE__*/React.createElement(Component, {
    key: `${label}-${optionValue}`,
    horizontal: horizontal,
    label: label,
    hideLabel: hideLabel,
    checked: value.includes(optionValue),
    disabled: disabled,
    onChange: () => toggleOption(optionValue)
  }))));
};
export default CheckboxGroup;
//# sourceMappingURL=index.js.map